export const itemClasses = {
  item: 'dnd__item',
  itemWrap: 'dnd__item__wrap',
  removeBtn: 'dnd__remove__btn',
  state: {
    sorting: 'state-sorting',
    dragging: 'state-dragging',
    dragOverlay: 'state-drag-overlay',
  },
};
